if (!customElements.get('custom-before-afters-grid')) {
  customElements.define(
    'custom-before-afters-grid',
    class CustomBeforeAftersGrid extends HTMLElement {
      connectedCallback() {
        this.initialVisible = Number(this.dataset.initialVisible) || 6;
        this.slider = this.querySelector('[data-before-afters-grid-slider]');
        this.originalCount = Number(this.slider?.dataset.originalCount) || 0;
        this.loadMoreButton = this.querySelector('[data-before-afters-grid-load-more]');
        this.previousButton = this.querySelector('[data-before-afters-grid-prev]');
        this.nextButton = this.querySelector('[data-before-afters-grid-next]');
        this.pagination = this.querySelector('[data-before-afters-grid-dots]');
        this.mobileMediaQuery = window.matchMedia('(max-width: 767px)');

        this.onLoadMore = this.onLoadMore.bind(this);
        this.onSectionLoad = this.onSectionLoad.bind(this);
        this.onMediaChange = this.onMediaChange.bind(this);

        this.loadMoreButton?.addEventListener('click', this.onLoadMore);
        document.addEventListener('shopify:section:load', this.onSectionLoad);
        this.mobileMediaQuery.addEventListener('change', this.onMediaChange);

        this.initSlider();
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        this.loadMoreButton?.removeEventListener('click', this.onLoadMore);
        this.mobileMediaQuery.removeEventListener('change', this.onMediaChange);
        this.destroySlider();
      }

      onSectionLoad(event) {
        if (event.target?.contains(this)) {
          this.destroySlider();
          this.initSlider();
        }
      }

      onMediaChange() {
        this.destroySlider();
        this.initSlider();
      }

      onLoadMore() {
        this.classList.add('is-load-more-expanded');
        this.loadMoreButton?.setAttribute('aria-expanded', 'true');
      }

      async initSlider() {
        if (!this.slider || !this.mobileMediaQuery.matches || this.originalCount === 0) {
          return;
        }

        if (this.slider.swiper) {
          return;
        }

        await this.waitForSwiper();

        this.swiper = new Swiper(this.slider, {
          slidesPerView: 'auto',
          spaceBetween: 15,
          loop: true,
          centeredSlides: true,
          allowTouchMove: true,
          grabCursor: true,
          speed: 500,
          navigation: {
            nextEl: this.nextButton,
            prevEl: this.previousButton,
          },
          pagination: {
            el: this.pagination,
            type: 'bullets',
            clickable: true,
            bulletClass: 'custom-before-afters-grid__dot',
            bulletActiveClass: 'is-active',
            renderBullet: (index, className) => {
              if (this.originalCount > 0 && index >= this.originalCount) {
                return `<button class="${className}" type="button" tabindex="-1" aria-hidden="true" style="display:none"></button>`;
              }

              return `<button class="${className}" type="button" aria-label="Show result ${index + 1}"></button>`;
            },
          },
          on: {
            slideChange: (swiper) => {
              if (!this.originalCount || !this.pagination) {
                return;
              }

              const realIndex = swiper.realIndex % this.originalCount;
              const bullets = this.pagination.querySelectorAll('.custom-before-afters-grid__dot');

              bullets.forEach((bullet, index) => {
                bullet.classList.toggle('is-active', index === realIndex);
              });
            },
          },
        });
      }

      destroySlider() {
        this.swiper?.destroy?.();
        this.swiper = null;
      }

      waitForSwiper() {
        return new Promise((resolve) => {
          if (window.Swiper) {
            resolve();
            return;
          }

          const checkSwiper = () => {
            if (window.Swiper) {
              resolve();
              return;
            }

            window.setTimeout(checkSwiper, 50);
          };

          checkSwiper();
        });
      }
    },
  );
}
